module.exports = __webpack_public_path__ + "static/media/simplonbp-light-webfont.50b28d64.woff";